module.exports = __webpack_public_path__ + "img/testimonials-stars.e8aa0dfa.svg";